import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card-body"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Descrição",
      "label-for": "descricao"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "descricao",
      "state": _vm.validateState('descricao'),
      "autofocus": ""
    },
    model: {
      value: _vm.$v.form.descricao.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.descricao, "$model", $$v);
      },
      expression: "$v.form.descricao.$model"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status",
      "label-for": "status"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.status,
      expression: "form.status"
    }],
    attrs: {
      "id": "status",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.status) ? _vm._i(_vm.form.status, null) > -1 : _vm.form.status
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.form.status,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "status", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "status", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "status", $$c);
        }
      }
    }
  }), _c('span')])])])], 1)], 1), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "7"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Serviço",
      "label-for": "servico"
    }
  }, [_c('VueSelect', {
    ref: "buscarServico",
    attrs: {
      "id": "servico",
      "filterable": false,
      "options": _vm.servicosFetched,
      "label": "discriminacao"
    },
    on: {
      "search": _vm.onSearchServico,
      "input": _vm.setServico
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_vm._v(" " + _vm._s(option.discriminacao) + " ")];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_vm._v(" " + _vm._s(option.discriminacao) + " ")];
      }
    }]),
    model: {
      value: _vm.servicoSelected,
      callback: function callback($$v) {
        _vm.servicoSelected = $$v;
      },
      expression: "servicoSelected"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Busque o serviço pela descrição ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Preço da lista R$",
      "label-for": "preco_lista"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "preco_lista"
    },
    model: {
      value: _vm.precoLista,
      callback: function callback($$v) {
        _vm.precoLista = $$v;
      },
      expression: "precoLista"
    }
  }, 'money', _vm.priceOptions, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('button', {
    staticClass: "btn btn-info btn-hover-dark font-weight-bolder mt-8",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addServico
    }
  }, [_vm._v(" Adicionar ")])])], 1), _c('b-row', [_c('b-col', [_c('TableApp', {
    key: _vm.keyToRender,
    attrs: {
      "item": "serviço",
      "titulo": "Serviços da lista",
      "subTitulo": "",
      "data": _vm.servicos,
      "fields": _vm.fields,
      "classFilterColumn": "discriminacao"
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field === 'discriminacao' ? _c('span', {
          staticClass: "font-weight-bold text-muted",
          attrs: {
            "slot": "discriminacao"
          },
          slot: "discriminacao"
        }, [_vm._v(" " + _vm._s(props.rowData.discriminacao) + " ")]) : _vm._e(), props.field === 'preco_lista' ? _c('span', {
          staticClass: "text-dark-75 font-weight-bolder",
          attrs: {
            "slot": "preco_lista"
          },
          slot: "preco_lista"
        }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(props.rowData.preco_lista, "preco")) + " ")]) : _vm._e(), props.field === 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('button', {
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.removerServico(props.rowData.id_servico);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)]) : _vm._e()];
      }
    }])
  })], 1)], 1)], 1), _c('div', {
    staticClass: "card-footer text-center"
  }, [_c('button', {
    ref: "submit_lista_preco_servico",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.salvarLista
    }
  }, [_vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'listaPrecosServicos'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };